// @flow
import type {Subscription} from 'digicel-kaizen-library';

export type SignUpActionType =
  | {|
      type: 'SIGNUP_TRIGGER_EMAIL_VALIDATION',
      payload: {|
        email: string,
        password: string,
        optionExternalCommercial?: boolean,
        optionInternalCommercial?: boolean,
      |},
    |}
  | {|
      type: 'SIGNUP_TRIGGER_EMAIL_VALIDATION_DURING_ACTIVATE',
      payload: {|
        email: string,
        password: string,
        optionExternalCommercial?: boolean,
        optionInternalCommercial?: boolean,
      |},
    |}
  | {|
      type: 'SIGNUP_RESEND_EMAIL',
    |}
  | {|
      type: 'SIGNUP_CONFIRM_SUBSCRIPTION_SELECTION_DURING_ACTIVATE',
      payload: {|
        subscription: ?Subscription,
      |},
    |}
  | {|
      type: 'SIGNUP_CONFIRM_REGION_DURING_ACTIVATE',
    |}
  | {|
      type: 'SIGNUP_CONFIRM_PLAN',
      payload?: {|
        isOrderingReplacementSim: ?boolean,
      |},
    |}
  | {|
      type: 'SIGNUP_REDIRECT_AFTER_ORDERING_SIM',
    |}
  | {|
      type: 'SIGNUP_ACTIVATE_SIM',
    |}
  | {|
      type: 'SIGNUP_GO_TO_NEXT_ACTIVATION_PAGE',
    |}
  | {|
      type: 'SIGNUP_GO_TO_NEXT_ESIM_PAGE',
      payload: {|
        routeName: ?string,
        params: ?Object,
      |},
    |}
  | {|
      type: 'SIGNUP_GO_TO_NEXT_ORDER_PAGE',
      payload: {|
        routeName?: string,
      |},
    |}
  | {|
      type: 'SIGNUP_VALIDATE_EMAIL',
      payload: {|
        code: string,
      |},
    |}
  | {|
      type: 'SIGNUP_VALIDATE_EMAIL_DURING_ACTIVATE',
      payload: {|
        code: string,
      |},
    |}
  | {|
      type: 'SIGNUP_INIT',
    |}
  | {|
      type: 'SIGNUP_INIT_SIM_REPLACEMENT',
    |}
  | {|
      type: 'SIGNUP_INIT_ESIM_REPLACEMENT',
      payload: {|
        subscription: ?Subscription,
      |},
    |}
  | {|
      type: 'SIGNUP_SET_GODFATHER_EXTERNAL_ID',
      payload: {|
        godfatherExternalId: string,
      |},
    |};

export const triggerEmailValidation = (formValues: {
  email: string,
  password: string,
  optionExternalCommercial: boolean,
  optionInternalCommercial: boolean,
}): SignUpActionType => ({
  type: 'SIGNUP_TRIGGER_EMAIL_VALIDATION',
  payload: {
    email: formValues.email,
    password: formValues.password,
    optionExternalCommercial: !!formValues.optionExternalCommercial,
    optionInternalCommercial: !!formValues.optionInternalCommercial,
  },
});

export const triggerEmailValidationDuringActivate = (formValues: {
  email: string,
  password: string,
}): SignUpActionType => ({
  type: 'SIGNUP_TRIGGER_EMAIL_VALIDATION_DURING_ACTIVATE',
  payload: {
    email: formValues.email,
    password: formValues.password,
  },
});

export const resendEmail = (): SignUpActionType => ({
  type: 'SIGNUP_RESEND_EMAIL',
});

export const validateEmail = (formValues: {
  code: string,
}): SignUpActionType => ({
  type: 'SIGNUP_VALIDATE_EMAIL',
  payload: {
    code: formValues.code,
  },
});

export const validateEmailDuringActivate = (formValues: {
  code: string,
}): SignUpActionType => ({
  type: 'SIGNUP_VALIDATE_EMAIL_DURING_ACTIVATE',
  payload: {
    code: formValues.code,
  },
});

export const confirmPlan = (
  isOrderingReplacementSim: ?boolean,
): SignUpActionType => ({
  type: 'SIGNUP_CONFIRM_PLAN',
  payload: {
    isOrderingReplacementSim,
  },
});

export const redirectAfterOrderingSIM = (): SignUpActionType => ({
  type: 'SIGNUP_REDIRECT_AFTER_ORDERING_SIM',
});

export const initializeSignUp = (): SignUpActionType => ({
  type: 'SIGNUP_INIT',
});

export const activateSim = (): SignUpActionType => ({
  type: 'SIGNUP_ACTIVATE_SIM',
});

export const goToNextActivationPage = (): SignUpActionType => ({
  type: 'SIGNUP_GO_TO_NEXT_ACTIVATION_PAGE',
});

export const goToNextOrderPage = (routeName?: string): SignUpActionType => ({
  type: 'SIGNUP_GO_TO_NEXT_ORDER_PAGE',
  payload: {
    routeName,
  },
});

export const goToNextEsimPage = (
  routeName?: string,
  params?: Object,
): SignUpActionType => ({
  type: 'SIGNUP_GO_TO_NEXT_ESIM_PAGE',
  payload: {
    routeName,
    params,
  },
});

export const confirmSubscriptionSelectionDuringActivate = (
  subscription: ?Subscription,
): SignUpActionType => ({
  type: 'SIGNUP_CONFIRM_SUBSCRIPTION_SELECTION_DURING_ACTIVATE',
  payload: {
    subscription,
  },
});

export const confirmRegionDuringActivate = (): SignUpActionType => ({
  type: 'SIGNUP_CONFIRM_REGION_DURING_ACTIVATE',
});

export const initSimReplacement = (): SignUpActionType => ({
  type: 'SIGNUP_INIT_SIM_REPLACEMENT',
});

export const initESimReplacement = (
  subscription: ?Subscription,
): SignUpActionType => ({
  type: 'SIGNUP_INIT_ESIM_REPLACEMENT',
  payload: {
    subscription,
  },
});
